export default __webpack_public_path__ + "static/media/wobbly.c9fff6ec.jpg";